import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Menu, MenuItem } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import EditIcon from '@material-ui/icons/Edit';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import axios from 'axios';
import { baseUrl } from 'Api';
import { AppContext, AuthContext } from 'Context';
import Spinner from 'Components/Spinner';
import { InfoModal } from '../private/dashboard/info-modal/index';
import SimpleSnackBar from '../../Components/SimpleSnackBar';
import UserList from './UserList';
import ManagerList from './ManagerList';
import RegisterPage from './RegisterPage';
import InviteUser from './InviteUser';
import AddBusiness from './AddBusiness';
import Copy from '../../Assets/link.png';
import './UserM.css';

function Affliated({ apiResponse }) {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [openBusinessModal, setOpenBusinessModal] = useState(false);
  const { getToken } = useContext(AuthContext);
  const { setAppSnackbar, setmangerFunctionData, setmessaged, messaged, setAffiliatedCode } = useContext(AppContext);
  const [data, setdata] = useState([]);
  const spinerSmall = 'spinex';
  const [userListData, setUserListData] = useState([]);
  const [giveResponse, setGiveResponse] = useState(false);
  const [hiddenIndices, setHiddenIndices] = useState([]);
  const [isOpenModal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [clickLoading, setClickLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openDropdown = Boolean(anchorEl);
  const frontEndUrl = window.location.origin;
  // if (frontEndUrl === 'https://projector.app') {
  //   frontEndUrl = 'https://projectorstream.com';
  // }

  // Store affiliate code in context when component mounts
  useEffect(() => {
    if (apiResponse?.data?.[0]?.affiliateCode) {
      setAffiliatedCode(apiResponse.data[0].affiliateCode);
    }
  }, [apiResponse, setAffiliatedCode]);

  const fetchData = async () => {
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/inviteUsersList`;
      const requestBody = {
        token: myToken,
      };
      const response = await axios.post(apiUrl, requestBody);
      setdata(response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const fetchMangerData = async () => {
    setIsLoading(true);
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/managerUsersList`;
      const requestBody = {
        token: myToken,
      };
      const response = await axios.post(apiUrl, requestBody);
      setUserListData(response.data);
      setIsLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      console.error('Error:', error);
      setIsLoading(false); // Set loading to false in case of an error
    }
  };
  const showAll = (showToast = true, clearHidden = true) => {
    setClickLoading(true);
    const API_URL = `${baseUrl}/showAllUsers`;
    const data = {
      token: getToken()
    };
    axios.post(API_URL, data)
      .then((response) => {
        setClickLoading(false);
        if (showToast) {
          setAppSnackbar({ isVisible: true, message: response?.data?.message, type: 'error' });
        }
        if (clearHidden) {
          setHiddenIndices([]);
        }
        fetchMangerData();
      })
      .catch((error) => {
        setClickLoading(false);
        if (showToast) {
          setAppSnackbar({ isVisible: true, message: error?.response?.message, type: 'error' });
        }
      });
  };
  const handleClick = (code) => {
    const textToCopy = `${frontEndUrl}/newSign-up?reference_code=${code}`;
    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    setmangerFunctionData(true);
    setmessaged('Affiliate link copied to clipboard');
  };

  const handleCreateUserClick = (event) => {
    // Only show dropdown for users with private plan access
    if (apiResponse?.data[0]?.private_plan_access === '1' || apiResponse?.data[0]?.private_plan_access === 1) {
      setAnchorEl(event.currentTarget);
    } else {
      // For all other users, directly go to User with Plan flow
      navigate('/create-user', { state: { userType: 'withPlan' } });
    }
  };

  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };

  const handleUserTypeSelect = (userType) => {
    handleCloseDropdown();
    navigate('/create-user', { state: { userType } });
  };
  return (
    <div
      className="relativez"
    // role="button"
    // tabIndex={0}
    // onClick={() => setIsOpen(false)}
    // onKeyDown={() => {}}
    >
      {isOpen && (
        <InviteUser
          fetchData={fetchData}
          getToken={getToken}
          setIsOpen={setIsOpen}
        />
      )}
      {openBusinessModal && (
        <AddBusiness
          setOpenBusinessModal={setOpenBusinessModal}
          name={apiResponse?.data[0]?.business_name}
        />
      )}
      <div className="gridssz relativez">
        <div>
          <p className="boldtext">User Permissions</p>
        </div>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0px' }}>
            <p
              className="nonBoldxtext"
              style={{
                visibility: apiResponse?.data[0]?.business_name ? '' : 'hidden',
                fontSize: '20px',
                fontWeight: '600',
              }}
            >
              {apiResponse?.data[0]?.business_name}
            </p>
            {apiResponse?.data[0]?.affiliateCode && (
              <div
                role="button"
                tabIndex={0}
                onKeyDown={() => { }}
                className="invite alignleft"
                onClick={() => setOpenBusinessModal(true)}
              // style={{ margin: '10px 0px' }}
              >
                {apiResponse?.data[0]?.business_name ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    Edit Business name
                    <EditIcon style={{ marginLeft: '8px', fontSize: '1rem' }} />
                  </div>
                ) : 'Add Business name +'}
              </div>
            )}
          </div>
          {(apiResponse?.data?.manager_status === 'Pending' || apiResponse?.data?.manager_status === 'Rejected') && (
            <div className="flexStarter">
              <p className="nonBoldxtext">Your Affiliate Code:</p>
              <button style={{ opacity: '0.5', cursor: 'default' }} className="buttonrEG">
                {apiResponse?.data?.manager_status}
                ....
              </button>
            </div>
          )}
          {apiResponse?.data[0]?.affiliateCode != null && (
            <span className="modelFelx">
              <p className="nonBoldxtext">
                Your Affiliate Code:
                {' '}
                {apiResponse?.data[0]?.affiliateCode}
              </p>
              <div
                onKeyPress={undefined}
                role="button"
                tabIndex={0}
                onClick={() => handleClick(apiResponse?.data[0]?.affiliateCode)}
              >
                <img
                  className="copy"
                  src={Copy}
                  alt=""
                />
              </div>
            </span>
          )}
          {apiResponse?.data[0]?.affiliateCode !== undefined
            && (
              <p className="linkSelectText">{`${frontEndUrl}/newSign-up?reference_code=${apiResponse?.data[0]?.affiliateCode}`}</p>
            )}
          <p className="nonColurxtext">Create and manage users</p>
        </div>
        <div className="mt-[37px]">
          <p className="nonBoldxtext">Connected Accounts:</p>
          <p className="nonColurxtext">Allow people access to your account</p>
          <button className="inviteer" onClick={() => setIsOpen(true)}>
            Invite User+
          </button>
          <div className="marginTopic">
            <UserList fetchData={fetchData} data={data} getToken={getToken} />
          </div>
        </div>
        {/* <p className="invite absolute">Create a new user +</p> */}
        <div>
          <div className="flexManager">
            <p className="nonBoldxtext">Access to:</p>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              {/* {apiResponse?.data[0]?.affiliateCode && (
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => {}}
                  className="cloudUploadButton"
                  onClick={() => navigate('/cloud-upload')}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
                    <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
                  </svg>
                  Upload from Cloud
                </div>
              )} */}
              {apiResponse?.paymentMethod === true ? (
                <>
                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={() => { }}
                    className="invite alignleft"
                    onClick={handleCreateUserClick}
                    style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                  >
                    Create a new user +
                    {/* {apiResponse?.data[0]?.affiliateCode === '01026' && (
                      <ArrowDropDownIcon style={{ fontSize: '20px' }} />
                    )} */}
                    {(apiResponse?.data[0]?.private_plan_access === '1' || apiResponse?.data[0]?.private_plan_access === 1) && (
                      <ArrowDropDownIcon style={{ fontSize: '20px' }} />
                    )}
                  </div>
                  <Menu
                    anchorEl={anchorEl}
                    open={openDropdown}
                    onClose={handleCloseDropdown}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      style: {
                        marginTop: '8px',
                      },
                    }}
                  >
                    <MenuItem onClick={() => handleUserTypeSelect('quick')} className="customMenuItem">
                      <FlashOnIcon style={{ marginRight: '12px', fontSize: '20px', color: '#000000' }} />
                      Quick user
                    </MenuItem>
                    <MenuItem onClick={() => handleUserTypeSelect('withPlan')} className="customMenuItem">
                      <PersonAddIcon style={{ marginRight: '12px', fontSize: '20px', color: '#000000' }} />
                      User with plan
                    </MenuItem>
                  </Menu>
                </>
              ) : (
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => { }}
                  onClick={() => {
                    setGiveResponse(true);
                    setmessaged(
                      'Please attach a payment method to create a user. Go to Settings > Billing and Payments > Manage payment info, to add your card details'
                    );
                  }}
                  style={{ opacity: '0.5' }}
                  className="invite alignleft"
                >
                  Create a new user +
                </div>
              )}
            </div>
          </div>
          <div className="flexManager" style={{ justifyContent: 'space-between' }}>
            <p className="nonColurxtext">Accounts that you have access to</p>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setModal(true)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { setModal(true); } }}
              style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                color: '#5aa5ef',
                fontSize: '14px',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
              onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
            >
              View all
              {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg> */}
            </span>
          </div>
          <div className="marginTopic">
            <ManagerList isLoading={isLoading} fetchMangerData={fetchMangerData} userListData={userListData} setUserListData={setUserListData} setModal={setModal} isOpenModal={isOpenModal} hiddenIndices={hiddenIndices} setHiddenIndices={setHiddenIndices} getToken={getToken} showAll={showAll} clickLoading={clickLoading} />
          </div>
        </div>
      </div>
      {giveResponse === true && (
        <SimpleSnackBar setOpen={setGiveResponse} message={messaged} />
      )}
    </div>
  );
}

export default Affliated;
